import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const MaskLines = ({ lines, className = "", delay = 0, animateOnLoad = false, lineClass = "" }) => {
  const parent = animateOnLoad
    ? { initial: "hidden", animate: "show" }
    : { initial: "hidden", whileInView: "show", viewport: { once: true, amount: 0.1 } };
  return (
    <motion.span className={`block ${className}`} {...parent}>
      {lines.map((l, i) => (
        <span key={`${l}-${i}`} className="block overflow-hidden pb-[0.08em]">
          <motion.span
            className={`block ${lineClass}`}
            variants={{ hidden: { y: "105%" }, show: { y: "0%" } }}
            transition={{ duration: 1.1, ease: EASE, delay: delay + i * 0.11 }}
          >
            {l}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

export const Label = ({ children, light = false }) => (
  <div className={`flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.3em] ${light ? "text-stone-300" : "text-stone-500"}`}>
    <span className="h-px w-8 bg-[#A8874F]" />
    {children}
  </div>
);

export { EASE };
